export default {
      id: "ic-para-phone-usage",
      viewBox: "0 0 26 26",
      url: "../dist/images/" + "sprite.svg#ic-para-phone-usage",
      toString: function () {
        return this.url;
      }
    }